export const API_BASE_URL = "https://restcountries.com/v3.1";
//
